export default "__VITE_ASSET__BB6nB0kv__"